<template>
  <v-app-bar fixed class="hpo_color">
    <v-app-bar-nav-icon @click.stop="handleDrawerToggle" class="hpo_color"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    
    <!-- Notification Bell Dropdown -->
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
      :close-on-content-click="false"
      v-model="notificationMenu"
      class="pr-3"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon large v-on="on" class="mr-2">
          <v-badge
            color="red"
            overlap
            :content="unreadCount"
            :value="unreadCount > 0"
          >
            <v-icon color="black">notifications</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <notification-list @close-menu="notificationMenu = false"></notification-list>
    </v-menu>

    <!-- User Profile Dropdown -->
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
      class="pr-3"
    >
      <template v-slot:activator="{ on }">
        <v-btn large text v-on="on">
          <v-label class="white--text mr-2">{{userName}}</v-label>
          <v-avatar size="30px">
            <img :src="computeAvatar || '/static/avatar/avatar.png'" alt="HPO" />
          </v-avatar>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item,index) in items"
          :to="!item.name ? null : { name: item.name }"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import _ from "lodash";

export default {
  name: "app-toolbar",
  components: {
    NotificationList
  },
  data: () => ({
    notificationMenu: false,
    items: [
      {
        icon: "manage_accounts",
        name: "Profile",
        title: "Tài khoản",
        click: e => {
          // Handled by :to="{ name: 'Profile' }"
        }
      },
      {
        icon: "logout",
        href: "#",
        title: "Đăng xuất",
        click: () => {
          window.getApp.$emit("APP_LOGOUT");
        }
      }
    ]
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    userName() {
      return this.$store.state.authentication.user ? this.$store.state.authentication.user.username : '';
    },
    computeAvatar() {
      return process.env.NODE_ENV === "production" ? '/static/avatar/avatar.png' : '';
    },
    unreadCount() {
      return (this.$store.state.notification.top5 || []).length;
    }
  },
  created() {
    this.fetchNotifications();
    this.timer = setInterval(() => {
      this.fetchNotifications();
    }, 30000); // Check every 30s
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    fetchNotifications() {
      if (this.$store.state.authentication && this.$store.state.authentication.token) {
        this.$store.dispatch("notification/getTop5").catch(err => {
          console.error("Failed to fetch notifications", err);
        });
      }
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
